export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/0c7f90dcab4574f291a5b93f31621815.svg";